export const state = () => ({
  resolved: {},
  loading: false,
})

export const mutations = {
  setResolved(state, list) {
    const map = {}
    for (const entry of list) {
      map[entry.key] = entry
    }
    state.resolved = map
  },

  mergePreference(state, entry) {
    state.resolved = { ...state.resolved, [entry.key]: entry }
  },

  setLoading(state, value) {
    state.loading = value
  },
}

export const getters = {
  get: (state) => (key) => {
    const entry = state.resolved[key]
    return entry ? entry.value : null
  },
  scope: (state) => (key) => {
    const entry = state.resolved[key]
    return entry ? entry.scope : null
  },
}

export const actions = {
  fetchAll({ commit }) {
    commit('setLoading', true)
    return this.$axios
      .$get('admin/preferences')
      .then((response) => {
        commit('setResolved', response.data)
      })
      .finally(() => {
        commit('setLoading', false)
      })
  },

  setPreference({ commit }, { key, value, scope }) {
    return this.$axios.$put(`admin/preferences/${key}`, { value, scope }).then((response) => {
      commit('mergePreference', response.data)
      return response.data
    })
  },
}
